import React from "react";
import Ansiedade from "../assets/Ansiedade.jpeg";

const AnsiedadePage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      {/* Contêiner principal */}
      <div className="flex flex-col md:flex-row items-center max-w-4xl w-full">
        {/* Imagem (sempre centralizada) */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={Ansiedade}
            alt="Ansiedade"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Texto (sempre centralizado) */}
        <div className="w-full md:w-1/2 mt-6 md:mt-0 md:pl-8 text-center">
          <h1 className="text-3xl font-bold text-[#ad6a51] mb-4">Ansiedade</h1>
          <p className="text-lg text-[#4a4a4a] leading-relaxed">
            Angústia é aquela sensação que te diz: ⚠️ É bom você ficar alerta!
            ⚠️
            <br />
            <br />
            Angústia, ou ansiedade, é esse estado de alerta para uma possível
            ameaça. Mas quando você está nessa situação, as reações possíveis
            são a luta ou a fuga. Muitas vezes, alguma dessas reações acaba não
            sendo tão racional, mas uma reação emocional a uma sensação de
            vulnerabilidade.
            <br />
            <br />
            Para entender o funcionamento destes sentimentos e comportamentos,
            um caminho possível é poder revisar a própria história, as próprias
            vivências. Entender o que da sua história lhe é referência de
            angústia e, assim, poder acolher seus sentimentos e dar um novo
            significado as suas experiências.
            <br />
            <br />É libertador cuidar dos próprios sentimentos e traumas. É
            poder viver uma vida mais leve, poder dar um novo tom a sua história
            e se tratar com mais amor e cuidado!
          </p>
        </div>
      </div>
    </div>
  );
};

export default AnsiedadePage;
